import { type QuestionPropsBase } from "features/Library/Common/QuestionsForm/types";
import { type Question } from "features/Library/Assessments/types/state";
import { TextQuestion } from "features/Library/Common/QuestionsForm/Questions/QuestionFields/TextQuestion/TextQuestion";

export type TextQuestionProps = QuestionPropsBase<Question>;

export const AssessmentTextQuestion = (props: TextQuestionProps) => {
  const { question, propertyNamePrefix, ...restProps } = props;
  const propertyName = `${propertyNamePrefix}question.text`;

  return <TextQuestion question={question.text} propertyName={propertyName} {...restProps} />;
};
